module.exports = __webpack_public_path__ + "img/Gruppenführer_Sanitätsgruppe.87dbc283.svg";